<template>
    <div>
        <div class="">
            <div class="element-item">
              <span class="title">名称:</span>
              <a-input
                v-model:value="layerState.layerName"
                style="width:160px"
                placeholder="名称"
                @change="changeLayer"
              />
              <span class="del-style">
                <a-tooltip placement="top">
                    <template #title>
                    <span>删除</span>
                    </template>
                    <DeleteOutlined />
                </a-tooltip>
            </span>
            </div>
            <div
              class="longitude element-item"
              >
              <!-- v-if="layerState.currentType === geoType.Point" -->
              <span class="title">经度:</span>
              <a-input
                v-model:value="layerState.longitude"
                style="width:160px"
                placeholder="经度"
                @change="changeLayer"
              />
            </div>
            <div
              class="latitude element-item"
              >
              <!-- v-if="layerState.currentType === geoType.Point" -->
              <span class="title">纬度:</span>
              <a-input
                v-model:value="layerState.latitude"
                style="width:160px"
                placeholder="纬度"
                @change="changeLayer"
              />
            </div>
            <div class="color-content">
              <span class="mr30">颜色: </span>
              <div
                v-for="item in colors"
                :key="item.id"
                class="color-item"
                :style="'background:' + item.color"
                @click="changeColor(item)"
              >
                <svg-icon
                  v-if="item.color === layerState.color"
                  :size="18"
                  name="check"
                ></svg-icon>
              </div>
            </div>
          </div>
          <!-- <div class="flex-row flex-justify-around flex-align-center mt20">
            <a-button type="primary" @click="deleteElement">删除</a-button>
          </div> -->
    </div>
</template>
<script setup lang="ts">
import { reactive , ref, watch} from 'vue';
import { Color, GeoType } from '/@/types/mapLayer'
import { DeleteOutlined } from '@ant-design/icons-vue'
const geoType = GeoType
const props = defineProps({
    entityData: {
        type: Object,
        default: ()=>{
            return {}
        }
    }
})
const layerState = reactive({
  layerName: '',
  layerId: '',
  longitude: 0,
  latitude: 0,
  currentType: '', // “LineString”,"Polygon","Point"
  color: '#212121'
})
const colors = ref<Color[]>([
  { id: 1, name: 'BLUE', color: '#2D8CF0', selected: true },
  { id: 2, name: 'GREEN', color: '#19BE6B', selected: false },
  { id: 3, name: 'YELLOW', color: '#FFBB00', selected: false },
  { id: 4, name: 'ORANGE', color: '#B620E0', selected: false },
  { id: 5, name: 'RED', color: '#E23C39', selected: false },
  { id: 6, name: 'NAME_DEFAULT', color: '#212121', selected: false }
])
// input框改变
function changeLayer (val: string) {
  console.log(70,val);
}
// 颜色改变
function changeColor (color: Color) {
  layerState.color = color.color
//   updateElements()
}
// 删除
async function deleteElement () {
    console.log('删除');
    
}
watch(()=>props.entityData,(data)=>{
    // console.log(1111,data);
    
},{
    deep:true
})
</script>
<style lang="scss" scoped>
.color-content {
    display: flex;
    align-items: center;
    margin-top: 8px;
    .color-item {
      cursor: pointer;
      width: 18px;
      height: 18px;
      line-height: 18px;
      display: flex;
      align-items: center;
      margin-left: 5px;
    }
  }
 .title {
    display: inline-flex;
    width: 80px;
  }
  .element-item {
    margin-bottom: 10px;
  }
  .del-style{
    font-size: 18px;
    margin-left: 10px;
    cursor: pointer;
  }
</style>